import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { BiMove } from "react-icons/bi";
import { Modal } from "react-bootstrap";
import { FaEllipsisH } from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";
import { handleException } from "../../app/util/util";
import { useSelector, useDispatch } from "react-redux";
import DropdownButton from "react-bootstrap/DropdownButton";
import { setLabelSettingsVOList } from "../../app/redux/UserSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
// 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup
const BRIEF_DEFAULT_TITLES = {
  "#ede48c": "Yellow Notes",
  "#b5eb97": "Green Notes",
  "#aee6fe": "Blue Notes",
  "#fec0ff": "Pink Notes",
  "#ffd4a8": "Orange Notes",
  "#cbbefc": "Purple Notes",
  "#35fbe2": "Cyan Notes",
  "#95a7ff": "Light Navy Notes",
  "#ff8787": "Light Coral Notes",
  "#c1a88e": "Sandrift Notes",
  "#dadada": "Gainsboro Notes",
  underline: "Underline Notes",
};
// 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup
const hasBriefLabel = (labelName) => !!(labelName && String(labelName).trim());
// 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup
const getBriefDefaultTitle = (colorCode) =>
  BRIEF_DEFAULT_TITLES[String(colorCode || "").toLowerCase()] || "Notes";
// 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (heading html for the manual label edit/cancel updates)
const getBriefTitleHtml = (labelName, colorCode) =>
  hasBriefLabel(labelName)
    ? labelName
    : `<span class="sr-only brief-default-title">${getBriefDefaultTitle(colorCode)}</span>`;
function BriefContainer(props) {
  const conid = useRef("");
  const dispatch = useDispatch();
  const { userVO, labelVOList } = props;
  const currUserVO = useSelector((s) => s.userVO);
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const handleSetLabelSettingsVOList = (labelSettings) =>
    dispatch(setLabelSettingsVOList(labelSettings));
  const [state, setState] = useState({
    isOpen: false,
    labelVOList: labelVOList
      ? Array.isArray(labelVOList)
        ? labelVOList
        : [labelVOList]
      : undefined,
    rawLabelVOList: labelVOList
      ? Array.isArray(labelVOList)
        ? labelVOList
        : [labelVOList]
      : undefined,
  });
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;
    var changedLabelVOList = reorder(
      state.labelVOList,
      result.source.index,
      result.destination.index,
    );
    changedLabelVOList = JSON.parse(JSON.stringify(changedLabelVOList));
    changedLabelVOList.forEach((val, index) => {
      val.orderIndex = index + 1;
    });
    updateLabelOrdering(changedLabelVOList);
    // setState({ ...state, labelVOList: changedLabelVOList });
    setState((prev) => ({
      ...prev,
      labelVOList: changedLabelVOList,
    }));
  };
  const editHighliterLabel = (e) => {
    conid.current =
      e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.id;
    let aseditHighliterLabel = document.querySelector(
      "[id='" +
        e.currentTarget.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement.id +
        "'] .colorLabelName",
    );
    var labelText = aseditHighliterLabel.textContent;
    // 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (do not prefill the input with the screen-reader-only default title)
    if (aseditHighliterLabel.querySelector(".brief-default-title"))
      labelText = "";
    let colorCode = e.target.getAttribute("colorCode");
    let orderIndex = e.target.getAttribute("orderIndex");
    var i = document.getElementsByClassName("editHighliterLabel");
    ReactDOM.render(
      <div className="display-inline-block" id="editHighlighterLabelBlock">
        <input
          data-testid="editHighliterLabel"
          autoFocus
          type="text"
          name="labelName"
          aria-label="Edit highlighter label"
          key={props.pCaseSectionId + "_" + colorCode}
          colorCode={colorCode}
          orderIndex={orderIndex}
          defaultValue={labelText}
          className="editHighliterLabel"
          onBlur={() => setState({ ...state, isOpen: true })}
          onKeyPress={handleLabelKeyPress}
          onChange={handleChange}
          style={{ visibility: "visible" }}
        />
      </div>,
      aseditHighliterLabel,
    );
  };
  const handleLabelKeyPress = (target) => {
    if (target.charCode == 13) {
      target.currentTarget.removeAttribute("onBlur");
      setState({ ...state, isOpen: true });
    }
  };
  const updateLabelOrdering = (labelVOList) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          pageNavigatingTo: "CASES",
          pageNavigatingFrom: "CASES",
          lastActivityCode: "BOOKSHELF",
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
          lastReadBookId: props.bookVO.bookId,
        },
        sessionVO: getSessionVO(),
      },
      labelVOList: labelVOList,
      bookVO: { bookId: props.bookVO.bookId },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCases/saveLabelSettings`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "true" && data.labelVOList) {
          handleSetLabelSettingsVOList(
            Array.isArray(data.labelVOList)
              ? data.labelVOList
              : [data.labelVOList],
          );
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  useEffect(() => {
    if (navigator.onLine) {
      const refetchToApi = async () =>
        await getChapterBrief(props.pCaseChapterId, props.pCaseSectionId);
      refetchToApi();
    }
  }, [props.pCaseChapterId, props.pCaseSectionId]);
  useEffect(() => {
    if (
      currUserVO.labelSettingsVOList &&
      currUserVO.labelSettingsVOList !== undefined &&
      currUserVO.labelSettingsVOList !== null
    ) {
      const refetchToApi = async () =>
        await updateLabelSetting(state.labelVOList, state.rawLabelVOList);
      refetchToApi();
    }
  }, [currUserVO.labelSettingsVOList]);
  useEffect(() => {
    setState({
      ...state,
      labelVOList: filterLabel(
        state.rawLabelVOList,
        currUserVO.removedLabelVOList,
      ),
    });
  }, [currUserVO.removedLabelVOList]);
  useEffect(() => {
    updateBriefs();
  }, [currUserVO.reduxBriefVO]);
  useEffect(
    () => () => {
      if (navigator.onLine) {
        getBriefGandle();
      }
    },
    [currUserVO.reduxAnnotationVO],
  );
  const getBriefGandle = async () =>
    await getChapterBrief(props.pCaseChapterId, props.pCaseSectionId);
  const updateBriefs = () => {
    if (
      currUserVO.reduxBriefVO &&
      currUserVO.reduxBriefVO.annotationStatus &&
      currUserVO.reduxBriefVO.annotationStatus === "added"
    ) {
      let currentItem =
        Array.from(state.labelVOList).find(
          (element) =>
            element.colorCode === currUserVO.reduxBriefVO.highlightColorCode,
        ) || undefined;
      if (currentItem !== null && currentItem !== undefined) {
        if (
          currentItem.briefVOList &&
          currentItem.briefVOList !== null &&
          currentItem.briefVOList !== undefined
        ) {
          let newListOfBrief = Array.isArray(currentItem.briefVOList)
            ? currentItem.briefVOList
            : [currentItem.briefVOList];
          if (currUserVO.reduxBriefVO.sectionId === currentItem.sectionId) {
            currentItem = {
              ...currentItem,
              briefVOList: [...newListOfBrief, currUserVO.reduxBriefVO].sort(
                (a, b) =>
                  parseFloat(a.highlightStartOffset) -
                  parseFloat(b.highlightStartOffset),
              ),
            };
            const newlabelVOList = JSON.parse(
              JSON.stringify(state.labelVOList),
            ).map((e) =>
              e.colorCode === currentItem.colorCode
                ? { ...currentItem }
                : { ...e },
            );
            setState({
              ...state,
              rawLabelVOList: newlabelVOList,
              labelVOList: newlabelVOList,
            });
          }
        } else if (
          currUserVO.reduxBriefVO.sectionId === currentItem.sectionId
        ) {
          currentItem = {
            ...currentItem,
            briefVOList: [currUserVO.reduxBriefVO],
          };
          const newlabelVOList = JSON.parse(
            JSON.stringify(state.labelVOList),
          ).map((e) =>
            e.colorCode === currentItem.colorCode
              ? { ...currentItem }
              : { ...e },
          );
          setState({
            ...state,
            rawLabelVOList: newlabelVOList,
            labelVOList: newlabelVOList,
          });
        }
      }
    } else if (
      currUserVO.reduxBriefVO &&
      currUserVO.reduxBriefVO.annotationStatus &&
      (currUserVO.reduxBriefVO.annotationStatus === "updated" ||
        currUserVO.reduxBriefVO.annotationStatus === "updatedNote")
    ) {
      var labelVOList = state.labelVOList;
      labelVOList = Array.isArray(labelVOList) ? labelVOList : [labelVOList];
      labelVOList = JSON.parse(JSON.stringify(labelVOList));
      var rawLabelVOList = state.rawLabelVOList;
      rawLabelVOList = Array.isArray(rawLabelVOList)
        ? rawLabelVOList
        : [rawLabelVOList];
      rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
      var rtnRawLabelVOList = updateBriefInLabelVOList(
        rawLabelVOList,
        currUserVO.reduxBriefVO,
      );
      var rtnLabelVOList = updateBriefInLabelVOList(
        labelVOList,
        currUserVO.reduxBriefVO,
      );
      if (rtnRawLabelVOList && rtnLabelVOList)
        setState({
          ...state,
          rawLabelVOList: rtnRawLabelVOList,
          labelVOList: rtnLabelVOList,
        });
      else {
        var labelVOList = state.labelVOList;
        labelVOList = Array.isArray(labelVOList) ? labelVOList : [labelVOList];
        labelVOList = JSON.parse(JSON.stringify(labelVOList));
        var rawLabelVOList = state.rawLabelVOList;
        rawLabelVOList = Array.isArray(rawLabelVOList)
          ? rawLabelVOList
          : [rawLabelVOList];
        rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
        var rtnRawLabelVOList = reorderBriefInLabelVOList(
          rawLabelVOList,
          currUserVO.reduxBriefVO,
        );
        var rtnLabelVOList = reorderBriefInLabelVOList(
          labelVOList,
          currUserVO.reduxBriefVO,
        );
        if (rtnLabelVOList && rtnRawLabelVOList)
          setState({
            ...state,
            rawLabelVOList: rtnRawLabelVOList,
            labelVOList: rtnLabelVOList,
          });
      }
    } else if (
      currUserVO.reduxBriefVO &&
      currUserVO.reduxBriefVO.annotationStatus &&
      currUserVO.reduxBriefVO.annotationStatus === "deleted"
    ) {
      var labelVOList = state.labelVOList;
      labelVOList = Array.isArray(labelVOList) ? labelVOList : [labelVOList];
      labelVOList = JSON.parse(JSON.stringify(labelVOList));
      var rawLabelVOList = state.rawLabelVOList;
      rawLabelVOList = Array.isArray(rawLabelVOList)
        ? rawLabelVOList
        : [rawLabelVOList];
      rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
      var rtnRawLabelVOList = removeBriefFromLabelVOList(
        rawLabelVOList,
        currUserVO.reduxBriefVO,
      );
      var rtnLabelVOList = removeBriefFromLabelVOList(
        labelVOList,
        currUserVO.reduxBriefVO,
      );
      if (rtnLabelVOList && rtnRawLabelVOList)
        setState({
          ...state,
          rawLabelVOList: rtnRawLabelVOList,
          labelVOList: rtnLabelVOList,
        });
    } else if (
      currUserVO.reduxBriefVO &&
      currUserVO.reduxBriefVO.annotationStatus &&
      currUserVO.reduxBriefVO.annotationStatus === "deletedNote"
    ) {
      var labelVOList = state.labelVOList;
      labelVOList = Array.isArray(labelVOList) ? labelVOList : [labelVOList];
      labelVOList = JSON.parse(JSON.stringify(labelVOList));
      var rawLabelVOList = state.rawLabelVOList;
      rawLabelVOList = Array.isArray(rawLabelVOList)
        ? rawLabelVOList
        : [rawLabelVOList];
      rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
      if (
        handleRemoveNoteTextxFromCaseBriefs(rawLabelVOList) &&
        handleRemoveNoteTextxFromCaseBriefs(labelVOList)
      )
        setState({
          ...state,
          rawLabelVOList: handleRemoveNoteTextxFromCaseBriefs(rawLabelVOList),
          labelVOList: handleRemoveNoteTextxFromCaseBriefs(labelVOList),
        });
    }
  };
  const handleRemoveNoteTextxFromCaseBriefs = (caseBriefs = []) => {
    const newState = caseBriefs.map((entry) => {
      if (entry.briefVOList) {
        entry.briefVOList = Array.isArray(entry.briefVOList)
          ? entry.briefVOList
          : [entry.briefVOList];
        let newEntry = entry.briefVOList.map((brief) => {
          if (brief.annotationId === currUserVO.reduxBriefVO.annotationId) {
            brief = currUserVO.reduxBriefVO;
          }
          return brief;
        });
        entry.briefVOList = newEntry;
      }
      return entry;
    });
    return newState;
  };
  const removeBriefFromLabelVOList = (rawLabelVOList, reduxBriefVO) => {
    const newState = rawLabelVOList.map((entry) => {
      if (entry.briefVOList) {
        entry.briefVOList = Array.isArray(entry.briefVOList)
          ? entry.briefVOList
          : [entry.briefVOList];
        let newEntry = entry.briefVOList.filter((brief) => {
          return brief.annotationId !== reduxBriefVO.annotationId;
        });
        entry.briefVOList = newEntry;
      }
      return entry;
    });
    return newState;
  };
  const reorderBriefInLabelVOList = (rawLabelVOList, reduxBriefVO) => {
    rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
    var colorCode = "",
      existingBriefObj = null;
    for (var i = 0; i < rawLabelVOList.length; i++) {
      if (rawLabelVOList[i].briefVOList) {
        var briefVOList = Array.isArray(rawLabelVOList[i].briefVOList)
            ? rawLabelVOList[i].briefVOList
            : [rawLabelVOList[i].briefVOList],
          newBriefVOList = [],
          flag = false;
        if (briefVOList) {
          briefVOList = JSON.parse(JSON.stringify(briefVOList));
          for (var j = 0; j < briefVOList.length; j++) {
            if (reduxBriefVO.annotationId === briefVOList[j].annotationId) {
              existingBriefObj = briefVOList[j];
              colorCode = reduxBriefVO.highlightColorCode;
            } else {
              newBriefVOList.push(briefVOList[j]);
            }
          }
        }
        rawLabelVOList[i].briefVOList = newBriefVOList;
      }
    }
    var labelVO = rawLabelVOList.filter(
      (x) => x.colorCode === currUserVO.reduxBriefVO.highlightColorCode,
    )[0];
    if (labelVO) {
      var briefVOList = Array.isArray(labelVO.briefVOList)
          ? labelVO.briefVOList
          : [labelVO.briefVOList],
        newBriefVOList = [],
        flag = false;
      for (var i = 0; i < briefVOList.length; i++) {
        if (
          briefVOList !== undefined &&
          briefVOList[i] !== undefined &&
          !briefVOList[i].highlightStartOffset
        ) {
          newBriefVOList.push(briefVOList[i]);
        } else if (existingBriefObj) {
          if (
            briefVOList !== undefined &&
            briefVOList[i] !== undefined &&
            parseInt(briefVOList[i].highlightStartOffset) <
              parseInt(existingBriefObj.highlightStartOffset)
          ) {
            newBriefVOList.push(briefVOList[i]);
          } else if (!flag) {
            existingBriefObj = JSON.parse(JSON.stringify(existingBriefObj));
            existingBriefObj.highlightColorCode =
              currUserVO.reduxBriefVO.highlightColorCode;
            existingBriefObj.noteText = currUserVO.reduxBriefVO.noteText;
            newBriefVOList.push(existingBriefObj);
            if (briefVOList[i] !== undefined) {
              newBriefVOList.push(briefVOList[i]);
            }
            flag = true;
          } else if (briefVOList[i] !== undefined) {
            newBriefVOList.push(briefVOList[i]);
          }
        }
      }
      if (!flag && existingBriefObj) {
        existingBriefObj = JSON.parse(JSON.stringify(existingBriefObj));
        existingBriefObj.highlightColorCode =
          currUserVO.reduxBriefVO.highlightColorCode;
        existingBriefObj.noteText = currUserVO.reduxBriefVO.noteText;
        newBriefVOList.push(existingBriefObj);
      }
      for (var i = 0; i < rawLabelVOList.length; i++) {
        if (
          rawLabelVOList[i].colorCode ===
          currUserVO.reduxBriefVO.highlightColorCode
        ) {
          rawLabelVOList[i].briefVOList = newBriefVOList;
        }
      }
      return rawLabelVOList;
    } else return rawLabelVOList;
  };
  const updateBriefInLabelVOList = (rawLabelVOList, reduxBriefVO) => {
    rawLabelVOList = JSON.parse(JSON.stringify(rawLabelVOList));
    var updateFlag = false;
    for (var i = 0; i < rawLabelVOList.length; i++) {
      if (rawLabelVOList[i].briefVOList) {
        var briefVOList = Array.isArray(rawLabelVOList[i].briefVOList)
            ? rawLabelVOList[i].briefVOList
            : [rawLabelVOList[i].briefVOList],
          newBriefVOList = [],
          flag = false;
        if (briefVOList) {
          briefVOList = JSON.parse(JSON.stringify(briefVOList));
          for (var j = 0; j < briefVOList.length; j++) {
            if (
              reduxBriefVO.highlightColorCode ===
                briefVOList[j].highlightColorCode &&
              reduxBriefVO.annotationId === briefVOList[j].annotationId
            ) {
              briefVOList[j].noteText = reduxBriefVO.noteText;
              updateFlag = true;
              break;
            }
          }
        }
      }
      if (updateFlag) {
        rawLabelVOList[i].briefVOList = briefVOList;
        break;
      }
    }
    if (updateFlag) return rawLabelVOList;
    else return null;
  };
  const updateLabelSetting = async (tempLabelVOList, rawtempLabelVOList) => {
    var labelSettingsVOList = currUserVO.labelSettingsVOList;
    var updatedLabelVOList = [],
      updatedRawtempLabelVOList = [];
    if (labelSettingsVOList && tempLabelVOList && rawtempLabelVOList) {
      labelSettingsVOList = Array.isArray(labelSettingsVOList)
        ? labelSettingsVOList
        : [labelSettingsVOList];
      for (var i = 0; i < labelSettingsVOList.length; i++) {
        for (var j = 0; j < tempLabelVOList.length; j++) {
          if (
            labelSettingsVOList[i].colorCode.toLowerCase() ===
            tempLabelVOList[j].colorCode.toLowerCase()
          ) {
            var temp = JSON.parse(JSON.stringify(tempLabelVOList[j]));
            temp.labelName = labelSettingsVOList[i].labelName;
            updatedLabelVOList.push(temp);
          }
        }
      }
      for (var i = 0; i < labelSettingsVOList.length; i++) {
        for (var j = 0; j < rawtempLabelVOList.length; j++) {
          if (
            labelSettingsVOList[i].colorCode.toLowerCase() ===
            rawtempLabelVOList[j].colorCode.toLowerCase()
          ) {
            var temp = JSON.parse(JSON.stringify(rawtempLabelVOList[j]));
            temp.labelName = labelSettingsVOList[i].labelName;
            updatedRawtempLabelVOList.push(temp);
          }
        }
      }
      await {
        ...state,
        labelVOList: updatedLabelVOList,
        rawLabelVOList: updatedRawtempLabelVOList,
      };
    }
  };
  const filterLabel = (rawLabel, removedLabelColorCode) => {
    var rtnLabel = [],
      flag = true;
    if (!removedLabelColorCode) return rawLabel;
    for (var i = 0; i < rawLabel.length; i++) {
      flag = true;
      for (var j = 0; j < removedLabelColorCode.length; j++) {
        if (typeof removedLabelColorCode[0] === "object") {
          if (
            rawLabel[i].colorCode &&
            removedLabelColorCode[j].highlightColorCode &&
            rawLabel[i].colorCode.toLowerCase() ===
              removedLabelColorCode[j].highlightColorCode.toLowerCase()
          ) {
            flag = false;
            break;
          }
        } else if (typeof removedLabelColorCode[0] === "string") {
          if (
            rawLabel[i].colorCode &&
            removedLabelColorCode[j] &&
            rawLabel[i].colorCode.toLowerCase() ===
              removedLabelColorCode[j].toLowerCase()
          ) {
            flag = false;
            break;
          }
        }
      }
      if (flag) rtnLabel.push(rawLabel[i]);
    }
    return rtnLabel;
  };
  const getChapterBrief = async (inputChapterId, inputSectionId) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          pageNavigatingTo: "CASES",
          pageNavigatingFrom: "CASES",
          lastActivityCode: "BOOKSHELF",
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
          lastReadSectionId: inputSectionId,
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: inputChapterId,
        },
        sessionVO: getSessionVO(),
      },
      briefVO: {
        pageNum: "0",
        sectionId: inputSectionId,
        bookId: props.bookVO.bookId,
        chapterId: inputChapterId,
        ereaderNotesAndHighlightsPopoverFlowFlag: false,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    if (inputChapterId) {
      try {
        const data = await (
          await fetch(
            `${localStorage.getItem("ENV")}/manageCases/getMyBriefContent`,
            requestOptions1,
          )
        ).json();
        if (data && data.status === "true") {
          if (data.labelVOList) {
            let briefLabelVOList = Array.isArray(data.labelVOList)
              ? data.labelVOList
              : [data.labelVOList];
            handleSetLabelSettingsVOList(briefLabelVOList);
            let filterList = filterLabel(
              briefLabelVOList,
              data.removedLabelColorCodes,
            );
            filterList = filterList.map((filter) => ({
              ...filter,
              sectionId: props.pCaseSectionId,
            }));
            setState({
              ...state,
              labelVOList: filterList,
              rawLabelVOList: briefLabelVOList,
            });
          } else {
            let reqData2 = {
              userVO: {
                userId: userVO.userId,
                userRole: userVO.userRole,
                userRoleId: userVO.userRoleId,
                userActivityVO: {
                  pageNavigatingTo: "CASES",
                  pageNavigatingFrom: "CASES",
                  lastActivityCode: "BOOKSHELF",
                  lastReadParagraphId: "para01",
                  lastReadSubSectionId: "subsec01",
                  lastReadSectionId: inputSectionId,
                  lastReadChapterId: inputChapterId,
                  lastReadBookId: props.bookVO.bookId,
                },
                sessionVO: getSessionVO(),
              },
            };
            const requestOptions2 = {
              method: "POST",
              body: JSON.stringify(reqData2),
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            };
            try {
              const data = await (
                await fetch(
                  `${localStorage.getItem("ENV")}/manageCases/getDefaultLabelSettings`,
                  requestOptions2,
                )
              ).json();
              if (data && data.status === "true") {
                if (data.labelVOList) {
                  let briefLabelVOList = Array.isArray(data.labelVOList)
                    ? data.labelVOList
                    : [data.labelVOList];
                  setState({
                    ...state,
                    labelVOList: briefLabelVOList,
                    rawLabelVOList: briefLabelVOList,
                  });
                } else
                  setState({
                    ...state,
                    labelVOList: null,
                    rawLabelVOList: null,
                  });
              } else if (data.wkErrorCode) {
                handleException(data);
              }
            } catch (error) {
              console.error(
                "There has been a problem with your fetch operation:",
                error,
              );
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      }
    }
  };
  const handleMouseLeaveForCustomNote = (e) => {
    if (e.target.getAttribute("customBriefAnnotationId") !== null) {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastViewedOutlineId: "",
            pageNavigatingTo: "CASES",
            pageNavigatingFrom: "CASES",
            lastActivityCode: "BOOKSHELF",
            lastReadParagraphId: "para01",
            lastReadSubSectionId: "subsec01",
            lastReadChapterId: props.chapterId,
            lastReadBookId: props.bookVO.bookId,
            lastReadSectionId: props.pCaseSectionId,
          },
          sessionVO: getSessionVO(),
        },
        briefVO: {
          bookId: props.bookVO.bookId,
          customNoteText: e.target.value,
          chapterId: props.pCaseChapterId,
          sectionId: props.pCaseSectionId,
          annotationId: e.target.getAttribute("customBriefAnnotationId"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageCases/updateCustomNoteForMyBrief`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status === "true") {
            console.info("Updated Custome Note successfully");
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    } else {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastViewedOutlineId: "",
            pageNavigatingTo: "CASES",
            pageNavigatingFrom: "CASES",
            lastActivityCode: "BOOKSHELF",
            lastReadParagraphId: "para01",
            lastReadSubSectionId: "subsec01",
            lastReadBookId: props.bookVO.bookId,
            lastReadChapterId: props.pCaseChapterId,
            lastReadSectionId: props.pCaseSectionId,
          },
          sessionVO: getSessionVO(),
        },
        briefVO: {
          pageNumber: "-999",
          chapterTitle: "-999",
          highlightText: "-999",
          highlightEndOffset: -999,
          highlightStartOffset: -999,
          highlightEndParaId: "-999",
          enclosingParaList: ["-999"],
          bookId: props.bookVO.bookId,
          highlightStartParaId: "-999",
          highlightParaEndOffset: -999,
          highlightParaStartOffset: -999,
          customNoteText: e.target.value,
          chapterId: props.pCaseChapterId,
          sectionId: props.pCaseSectionId,
          sectionTitle: props.pCaseNavtitle,
          highlightColorCode: e.target.getAttribute("colorCode"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageCases/addCustomNoteForMyBrief`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status === "true" && data.briefVO) {
            e.target.setAttribute("key", data.briefVO.annotationId);
            e.target.setAttribute(
              "customBriefAnnotationId",
              data.briefVO.annotationId,
            );
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const saveModal = async () => {
    let editLabelInput = document.querySelector(".editHighliterLabel");
    let editLabelInputValue = editLabelInput.value ? editLabelInput.value : "";
    let colorCode = editLabelInput.getAttribute("colorcode");
    let orderIndex = editLabelInput.getAttribute("orderIndex");
    let i = document.querySelector(
      "[id='" + conid.current + "'] .colorLabelName",
    );
    ReactDOM.unmountComponentAtNode(i);
    i.style.display = "inline-block";
    // i.innerHTML = editLabelInputValue;
    // 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (keep the screen-reader-only title when label is cleared)
    i.innerHTML = getBriefTitleHtml(editLabelInputValue, colorCode);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        streamContentRequiredFlag: false,
        userActivityVO: {
          lastReadBookId: "41",
          lastReadSectionId: "",
          lastReadPageNum: "312",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadChapterId: props.chapterId,
        },
        sessionVO: getSessionVO(),
      },
      bookVO: { bookId: props.bookVO.bookId },
      labelVOList: [
        {
          colorCode: colorCode,
          orderIndex: orderIndex,
          labelName: editLabelInputValue,
        },
      ],
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    if (colorCode !== undefined && colorCode.length > 0) {
      try {
        const data = await (
          await fetch(
            `${localStorage.getItem("ENV")}/manageCases/saveLabelSettings`,
            requestOptions1,
          )
        ).json();
        if (data && data.status === "true" && data.labelVOList) {
          handleSetLabelSettingsVOList(data.labelVOList);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        await setState({ ...state, isOpen: false });
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      }
    }
    setTimeout(() => {
      document.getElementById(`casebriefs_options_${orderIndex}`).click();
      document.getElementById(`casebriefs_options_${orderIndex}`).focus();
    }, 500);
  };
  const hideCaseBriefModal = () => {
    setState({ ...state, isOpen: false });
    let editLabelInput = document.querySelector(".editHighliterLabel");
    let orderIndex = editLabelInput.getAttribute("orderIndex");
    let i = document.querySelector(
      "[id='" + conid.current + "'] .colorLabelName",
    );
    ReactDOM.unmountComponentAtNode(i);
    i.style.display = "inline-block";
    // i.innerHTML = state.labelVOList[orderIndex - 1].labelName;
    // 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (keep the screen-reader-only title when label is empty)
    i.innerHTML = getBriefTitleHtml(
      state.labelVOList[orderIndex - 1].labelName,
      state.labelVOList[orderIndex - 1].colorCode,
    );
    setTimeout(() => {
      document.getElementById(`casebriefs_options_${orderIndex}`).click();
      document.getElementById(`casebriefs_options_${orderIndex}`).focus();
    }, 500);
  };
  return (
    <React.Fragment>
      <Modal
        className="modal fade"
        show={state.isOpen}
        onHide={hideCaseBriefModal}
        id="editHighlightModalLabel"
        tabindex="-1"
        role="dialog"
        aria-labelledby="editHighliterModalLabel"
        aria-hidden="true"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="editHighliterModalLabel">
            Case Brief Labels
          </h5>
          <Modal.Header closeButton />
        </div>
        <div className="modal-body">
          These changes will be applied to all case briefs for this book. Are
          you sure you want to save these changes?
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={hideCaseBriefModal}
          >
            No, Go Back
          </button>
          <button type="button" className="btn btn-primary" onClick={saveModal}>
            Yes, Save changes
          </button>
        </div>
      </Modal>
      <div id="briefNotes">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(droppableProvided, droppableSnapshot) => (
              <ul
                className="labelVOList"
                style={{ listStyleType: "none", padding: "0" }}
                ref={droppableProvided.innerRef}
                {...droppableProvided.droppableProps}
              >
                {state.labelVOList
                  ? state.labelVOList.map((label, index) => (
                      <Draggable
                        id={"brief_" + index}
                        key={label.labelId}
                        // draggableId={"brief_" + index}
                        draggableId={String(label.labelId)}
                        index={index}
                      >
                        {(draggableProvided, draggableSnapshot) => (
                          <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            // 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup
                            // Original: {...draggableProvided.dragHandleProps} (moved to the BiMove drag icon below so role="button"/aria-describedby no longer wrap the whole card)
                          >
                            <li>
                              <div
                                className="colorEditorContainer_cb mTopTen"
                                id={(label.labelName + label.colorCode).replace(
                                  "#",
                                  "Id",
                                )}
                              >
                                <div
                                  className="colorEditorTop_cb"
                                  style={{
                                    backgroundColor:
                                      label.colorCode !== "underline"
                                        ? label.colorCode
                                        : "",
                                    border:
                                      label.colorCode === "underline"
                                        ? "1px solid black"
                                        : null,
                                  }}
                                >
                                  <div className="colorLabelContainer">
                                    <div
                                      className="display-inline-block colorLabelBlock"
                                      style={{ padding: "6px 10px" }}
                                    >
                                      {/* 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup */}
                                      {/* Original: <span className="colorLabelName" style={{ verticalAlign: "text-top" }}> */}
                                      <h3
                                        className="colorLabelName"
                                        style={{ verticalAlign: "text-top" }}
                                      >
                                        {label.labelName}
                                        {/* 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (screen-reader-only default title when no label is saved) */}
                                        {!hasBriefLabel(label.labelName) && (
                                          <span className="sr-only brief-default-title">
                                            {getBriefDefaultTitle(
                                              label.colorCode,
                                            )}
                                          </span>
                                        )}
                                      </h3>
                                    </div>
                                    <div className="display-inline-block pull-right moveableBlock">
                                      {/* react-beautiful-dnd only accepts an HTMLElement as drag handle (an SVG icon is silently ignored and drag never starts), so the handle props live on this span wrapper rather than on the BiMove svg */}
                                      <span
                                        className="dragDropIcon mLeftFive display-inline-block"
                                        // 47046 - A11Y: Drag Case Brief note card button does not have an accessible name
                                        aria-label="Drag card"
                                        // 47037 - A11Y: My Notebook Case Brief note cards sections do not include heading markup (drag handle moved here from the outer card div)
                                        {...draggableProvided.dragHandleProps}
                                      >
                                        <BiMove aria-hidden="true" />
                                      </span>
                                      <DropdownButton
                                        className="ellipsisIcon mLeftFive display-inline-block"
                                        alignRight
                                        title={
                                          // 47047 - A11Y: Case Brief note card menu button does not have an accessible name
                                          <>
                                            {/* 47047 - A11Y: Case Brief note card menu button does not have an accessible name */}
                                            <span className="sr-only">
                                              Action Menu
                                            </span>
                                            <FaEllipsisH
                                              data-testid={`dropdown_${label.labelName}`}
                                              className="briefFaEllipsisHBtn"
                                              // 47047 - A11Y: Case Brief note card menu button does not have an accessible name
                                              aria-hidden="true"
                                            />
                                          </>
                                          // Original icon-only title (kept for reference, superseded by the accessible version above):
                                          // <FaEllipsisH
                                          //   data-testid={`dropdown_${label.labelName}`}
                                          //   className="briefFaEllipsisHBtn"
                                          // />
                                        }
                                        id={
                                          "casebriefs_options_" +
                                          label.orderIndex
                                        }
                                      >
                                        <Dropdown.Item
                                          eventKey="option-1"
                                          className="edit_highlight_option"
                                          colorCode={label.colorCode}
                                          orderIndex={label.orderIndex}
                                          onClick={editHighliterLabel}
                                        >
                                          Edit highlighter label
                                        </Dropdown.Item>
                                      </DropdownButton>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="colorEditorBox_cb"
                                  style={{
                                    width:
                                      localStorage.getItem("deviceType") ===
                                      "Desktop"
                                        ? "40vw"
                                        : "100%",
                                  }}
                                >
                                  {label.briefVOList !== undefined &&
                                  label.briefVOList.length !== 0 ? (
                                    label.briefVOList !== undefined ? (
                                      Array.isArray(label.briefVOList) ? (
                                        label.briefVOList.map((brief) =>
                                          brief.annotationId !== undefined ? (
                                            <div
                                              id={"case_" + brief.annotationId}
                                              annotationId={brief.annotationId}
                                              className="annotatedOutlineHighlightCont"
                                              style={{
                                                backgroundColor:
                                                  label.colorCode,
                                                color: "#000",
                                                textDecoration: label.colorCode,
                                              }}
                                            >
                                              {brief.highlightText}{" "}
                                              {brief.noteText ? (
                                                <div
                                                  style={{
                                                    borderTop:
                                                      "1px solid #000000",
                                                    fontStyle: "italic",
                                                    marginTop: "10px",
                                                    padding: "10px 10px 0px",
                                                    wordBreak: "break-word",
                                                  }}
                                                >
                                                  {" "}
                                                  {brief.noteText}
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          ) : null,
                                        )
                                      ) : label.briefVOList.annotationId !==
                                          undefined &&
                                        label.briefVOList !== undefined ? (
                                        <div
                                          id={
                                            "case_" +
                                            label.briefVOList.annotationId
                                          }
                                          annotationId={
                                            label.briefVOList.annotationId
                                          }
                                          className="annotatedOutlineHighlightCont"
                                          style={{
                                            backgroundColor: label.colorCode,
                                            color: "#000",
                                            textDecoration: label.colorCode,
                                          }}
                                        >
                                          {" "}
                                          {label.briefVOList.highlightText}
                                          {label.briefVOList.noteText ? (
                                            <div
                                              style={{
                                                borderTop: "1px solid #000000",
                                                fontStyle: "italic",
                                                marginTop: "10px",
                                                padding: "10px 10px 0px",
                                                wordBreak: "break-word",
                                              }}
                                            >
                                              {" "}
                                              {label.briefVOList.noteText}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      ) : null
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  )}
                                  <textarea
                                    data-testid="customNote"
                                    type="textarea"
                                    name="textValue"
                                    className="textAreaColorBox"
                                    aria-label="Add a brief"
                                    key={
                                      label.customBriefVOList !== undefined
                                        ? Array.isArray(label.customBriefVOList)
                                          ? label.customBriefVOList[0]
                                              .annotationId
                                          : label.customBriefVOList.annotationId
                                        : props.pCaseSectionId +
                                          "_" +
                                          label.colorCode
                                    }
                                    defaultValue={
                                      label.customBriefVOList !== undefined
                                        ? Array.isArray(label.customBriefVOList)
                                          ? label.customBriefVOList[0]
                                              .customNoteText
                                          : label.customBriefVOList
                                              .customNoteText
                                        : ""
                                    }
                                    colorCode={label.colorCode}
                                    onBlur={handleMouseLeaveForCustomNote}
                                    customBriefAnnotationId={
                                      label.customBriefVOList !== undefined
                                        ? Array.isArray(label.customBriefVOList)
                                          ? label.customBriefVOList[0]
                                              .annotationId
                                          : label.customBriefVOList.annotationId
                                        : null
                                    }
                                  />
                                </div>
                              </div>
                            </li>
                          </div>
                        )}
                      </Draggable>
                    ))
                  : ""}
                {droppableProvided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </React.Fragment>
  );
}
export default BriefContainer;
